import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import CartClass from './../../../../../../../js/classes/Cart'
import CatalogClass from './../../../../../../../js/classes/Catalog'

import Loading from './Loading.jsx'
import Empty from './Empty.jsx'
import Errors from './Errors.jsx'

import CartItem from './CartItem.jsx'

const Cart = ({ refetch, cart, setLoading, isHideErrors, setHideErrors }) => {
    //Закрыть цведомление о наличии товара
    const handleCloseError = () => {
        setHideErrors(true)
    }

    //Удалить товар из корзины
    const handleRemove = (item) => {
        setLoading(true)
        
        CartClass.remove(item.ID, (err, res) => {
            refetch(() => {
                
            })
        })
    }

    //Добавить в избранное
    const handleFavorite = (item, e) => {
        e.target.classList[(e.target.classList.contains('happy-cart__action_favorite_active')) ? 'remove' : 'add']('happy-cart__action_favorite_active')
        
        CatalogClass.addFavorite((err, res) => {
        }, item.PRODUCT_ID)
    }

    //Изменить количество
    const handleChange = (item, isPlus=true, { target, which }) => {
        if (!(isPlus === true || isPlus === false || isPlus === 'blur' || (isPlus === 'press' && which == 13))) return

        const parent = (isPlus === 'blur' || (isPlus === 'press' && which == 13)) ? target : target.parentNode.querySelector('.input-number__count'),
        value = parseInt(parent.value)
        
        let newQuantity = value
        
        if (isPlus === 'blur' || (isPlus === 'press' && which == 13)) {
            newQuantity = parseInt(value) || 1
            
            parent.value = newQuantity
        } else {
            newQuantity = isPlus ? value + 1 : value - 1

            if (newQuantity <= 0) newQuantity = 1

            parent.value = newQuantity
        }

        setLoading(true)

        CartClass.change(item.ID, newQuantity, (err, res) => {
            refetch(() => {
                
            })
        })
    }

    if (cart.items.length > 0) {
        //Позиции в корзине
        return <div className="happy-cart__items">
            <div className="happy-cart__header happy-cart_grid">
                <div className="happy-cart__header-th happy-cart__header-th_name">
                    Наименование
                </div>
                <div className="happy-cart__header-th happy-cart__header-th_price">
                    Цена
                </div>
                <div className="happy-cart__header-th happy-cart__header-th_quantity">
                    Количество
                </div>
                <div className="happy-cart__header-th happy-cart__header-th_summary">
                    Сумма
                </div>
                <div className="happy-cart__header-th happy-cart__header-th_actions">

                </div>
            </div>

            <div className="happy-cart__list">
                { cart.items.map((item) => {
                    return <CartItem
                        key={ `cart-item-${ item.ID }` }
                        item={ item }
                        handleRemove={ handleRemove }
                        handleFavorite={ handleFavorite }
                        handleChange={ handleChange }
                        handleCloseError={ handleCloseError }
                        isHideErrors={ isHideErrors }
                    />
                }) }
            </div>
        </div>
    } else {
        //Пустая корзина
        return <Empty />
    }
}

export default Cart